<script setup>
defineProps({
  title: { type: String, default: 'Ocorreu algo inesperado' },
  description: {
    type: String,
    default: 'Atualize a página para carregar as informações novamente.',
  },
  retryLabel: { type: String, default: 'Atualizar página' },
});

const emit = defineEmits(['retry']);
</script>

<template>
  <div
    class="rounded-lais border border-rose-100 bg-rose-50 px-5 py-8 text-center"
    role="alert"
    aria-live="assertive"
  >
    <span
      class="i-lucide-circle-alert mx-auto mb-3 block size-8 text-rose-500"
    />
    <p class="text-[14px] font-semibold text-lais-text">
      {{ title }}
    </p>
    <p
      v-if="description"
      class="mx-auto mt-1 max-w-[312px] text-[12px] text-lais-text-muted"
    >
      {{ description }}
    </p>
    <button
      type="button"
      class="mt-4 inline-flex h-9 items-center justify-center rounded-lais border border-rose-200 bg-white px-3 text-[13px] font-semibold text-rose-700 transition hover:bg-rose-100"
      :aria-label="retryLabel"
      @click="emit('retry')"
    >
      {{ retryLabel }}
    </button>
  </div>
</template>
